import { WitLabel } from "../shared/widgets/common";
import SelectGroup from "../witadmin/CRUD/Common/SelectGroup";
import React, { useCallback, useMemo } from "react";
import { FieldProps } from "react-jsonschema-form";
import styled from "styled-components";
import { defineMessages, FormattedMessage, useIntl } from "react-intl";
import { Taxation } from "../../gen/witbooking/backoffice/taxation/v1/taxation_api_pb";
import { TYPE } from "./index";
import { useUserAuthInfo } from "../../lib/auth";

export const messages = defineMessages({
  taxPreferences: {
    id: "taxation.taxPreferences",
    defaultMessage: "Tax Preferences",
  },
  taxesIncluded: {
    id: "taxation.taxesIncluded",
    defaultMessage: "Taxes included in the rate - shown itemized at check-out"
  },
  taxesExcluded: {
    id: "taxation.taxesExcluded",
    defaultMessage: "Taxes not included in the rate - shown for information purposes only"
  },
  taxesIncludedInCheckout: {
    id: "taxation.taxesIncludedInCheckout",
    defaultMessage: "Taxes not included in the rate - are added at check-out to the total amount of the reservation"
  },
  includedTaxHelpText: {
    id: "taxation.includedTaxHelpText",
    defaultMessage: "Only the taxes included in the rate will be applied"
  },
  excludedTaxHelpText: {
    id: "taxation.excludedTaxHelpText",
    defaultMessage: "Only the taxes excluded from the rate will be applied"
  },
});

const SelectGroupWrapper = styled.div`
  width: 100%;
`;

const DEFAULT_TAX_PREFERENCE = Taxation.TaxationPreference.INCLUDED;

export function TaxPreference({
  formData,
  onChange,
  schema,
}: FieldProps) {
  const userAuthInfo = useUserAuthInfo();
  const intl = useIntl();

  const optionDisplay = useMemo(() => ({
    [Taxation.TaxationPreference.INCLUDED]: {
      label: intl.formatMessage(messages.taxesIncluded),
    },
    [Taxation.TaxationPreference.EXCLUDED]: {
      label: intl.formatMessage(messages.taxesExcluded),
    },
    [Taxation.TaxationPreference.INCLUDED_IN_CHECKOUT]: {
      label: intl.formatMessage(messages.taxesIncludedInCheckout),
    },
  }), [intl]);

  const handleChange = useCallback(
    (data) => {
      onChange({
        ...formData,
        preference: Number(data.event.target.value),
      });
    },
    [formData, onChange]
  );

  if (!userAuthInfo?.isWitAdmin) {
    return null;
  }

  return (
    <div>
      <WitLabel>{schema?.title}</WitLabel>
      <SelectGroupWrapper>
        <SelectGroup
          value={formData.preference ?? DEFAULT_TAX_PREFERENCE}
          field={{
            fieldName: "preference",
            widget: "selector",
            optionDisplay,
          }}
          onChange={handleChange}
          errors={undefined}
          additionalFields={undefined}
          className="w-[670px]"
        />
        {formData.preference === Taxation.TaxationPreference.INCLUDED && (
            <label>
              *<FormattedMessage {...messages.includedTaxHelpText} />
            </label>
          )}
        {formData.preference !== Taxation.TaxationPreference.INCLUDED && (
            <label>
              *<FormattedMessage {...messages.excludedTaxHelpText} />
            </label>
          )}
      </SelectGroupWrapper>
    </div>
  );
}